import { Button } from "@mui/material";
import React from "react";
import useLiteratureCurrentView from "../hooks/useLiteratureCurrentView";
import { exitFullScreen, isInFullScreen } from '../../../helpers/fullScreenHelper';
import { useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import { usePhoneMode } from "../../../hooks";

export default function NavCloseButton() {
    const navigate = useNavigate();
    const { phoneMode } = usePhoneMode();
    const {
        isInDocumentView, isInVideoView, isInFaultView,
        faultViewFamilyId, isInEngineInfo, isInServiceLogView, isInServiceLogAddEdit
    } = useLiteratureCurrentView();

    if (!isInDocumentView && !isInVideoView && !isInFaultView &&
        !isInEngineInfo && !isInServiceLogView && !isInServiceLogAddEdit) {
        return null;
    }

    const buttonContent = !phoneMode ? <>Close</> : <CloseIcon />;

    const handleCloseClick = () => {
        if (isInFullScreen()) {
            exitFullScreen();
        }

        let closePath = '/literature';
        if (isInFaultView) {
            closePath = `/literature/fault/${faultViewFamilyId}`;
        }
        if (isInServiceLogView || isInServiceLogAddEdit) {
            closePath = `/literature/service/log`;
        }

        navigate(closePath);
    }

    return (
        <Button color="inherit" onClick={handleCloseClick}>{buttonContent}</Button>
    );
}